import { Injectable } from '@angular/core';
import { AppState, JobMediaFacadeBase } from '@app/state';
import { Store, select } from '@ngrx/store';
import { JobMedia, JobMediaVM } from '@app/models';
import { Observable } from 'rxjs';
import { selectJobDetailMedia } from '@app/state/job-details/job-details.selectors';
import { JobMediaService } from '@services/api/job-media.service';
import {
  createJobMedia,
  CreateJobMediaRequest,
} from '@app/state/job-media.effects';

@Injectable({ providedIn: 'root' })
export class JobMediaFacade extends JobMediaFacadeBase {
  constructor(
    private store: Store<AppState>,
    private mediaService: JobMediaService
  ) {
    super(JobMedia, store);
  }

  get detailedJobMediaVM$(): Observable<JobMediaVM[]> {
    return this.store.pipe(select(selectJobDetailMedia));
  }

  imageLink$(media: JobMedia): Observable<string> {
    return this.mediaService.getLink(media.id);
  }

  createMedia(payload: CreateJobMediaRequest) {
    this.store.dispatch(createJobMedia({ payload }));
  }

  bulkMediaDownload$(jobId: string, mediaIds: string[]) {
    return this.mediaService.bulkDownload$(jobId, mediaIds);
  }
}
